import Product from './Product'

export * from './Product'
export default Product
